import PropTypes from "prop-types";
import stageShape, { stageContentFor } from "../model/stage";
import CompleteStage from "./CompleteStage";
import InProgressStage from "./InProgressStage";

import { formatStageDate } from "./helpers";

const LADDER_STATUSES = ["open", "in_progress", "ready_to_close", "post_closing"];

const PRE_CONTRACT_LABEL = "Pre-Contract";
const PRE_CONTRACT_COMPLETE_TITLE = "Title Report Ready";
const PRE_CONTRACT_COMPLETE_TEXT =
  "The Title Report has now been prepared and uploaded for the appropriate parties to review in the Blueprint Portal.";

const BlueprintStage = ({ stage = null, isPreContract = false }) => {
  if (stage?.errorTitle) {
    return (
      <div className="tw-flex tw-flex-col tw-gap-[12px]">
        <div className="tw-flex tw-flex-col tw-gap-[2px] tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-neutral-gray-10 tw-p-[8px]">
          <span className="tw-text-14 tw-font-semibold tw-leading-20px tw-text-gray-75">
            {stage.errorTitle}
          </span>
          <span className="tw-text-12px tw-font-normal tw-leading-[16px] tw-text-gray-75">
            {stage.errorMessage}
          </span>
        </div>
      </div>
    );
  }

  const status = stage?.crmTransactionStatus;
  if (status === "complete") {
    if (isPreContract) {
      return <CompleteStage title={PRE_CONTRACT_COMPLETE_TITLE} text={PRE_CONTRACT_COMPLETE_TEXT} />;
    }

    return <CompleteStage />;
  }

  if (LADDER_STATUSES.includes(status)) {
    return <InProgressStage stage={stage} label={isPreContract ? PRE_CONTRACT_LABEL : null} />;
  }

  const content = stageContentFor(stage, isPreContract);

  if (!content) return null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[12px]">
      <div className="tw-flex tw-flex-col tw-gap-[2px] tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-neutral-gray-10 tw-p-[8px]">
        <span className="tw-text-14 tw-font-semibold tw-leading-20px tw-text-gray-75">
          {content.subtitle}
        </span>
        <span className="tw-text-12px tw-font-normal tw-leading-[16px] tw-text-gray-75">
          {content.description}
        </span>
      </div>
      <div className="tw-flex tw-justify-between tw-text-12px tw-font-normal tw-italic tw-leading-[16px] tw-text-gray-50">
        <span>{content.metadataLabel}</span>
        <span>{formatStageDate(stage.lastUpdated)}</span>
      </div>
    </div>
  );
};

BlueprintStage.propTypes = {
  stage: stageShape,
  isPreContract: PropTypes.bool,
};

export default BlueprintStage;
